import React, { useEffect, useCallback, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import Connect from "../../../shared/redux/Connect.hoc";
import LoaderSpinner from "../../../shared/components/LoaderSpinner/LoaderSpinner";
import MensajeriaTable from '../Tables/Mensajeria.table'
import DetalleMensajeria from './DetalleMensajeria.component'
import "./styles.scss";
import { createNotification, validateArray, presentconfirmAlert } from '../../../utils/utils'

// * Helpers
import { getMeMensajeriasHP } from '../../../helpers/Mensajeria.helper'

function ListMensajerias({ state }) {
  const [mensajerias, setMensajerias] = useState([])
  const [visibleDetalle, setVisibleDetalle] = useState(false)
  useEffect(() => {
    console.log("--ListMensajerias.Component.useEffect-- ");
    getMisMensajerias()
  }, []);

  const getMisMensajerias = async () => {
    console.log("--ListMensajerias.Component.getMisMensajerias-- ");
    try {
      const response = await getMeMensajeriasHP(state.auth.user._id)
      console.log("--ListMensajerias.Component.getMisMensajerias-- response: ", response);

      if (response['code'] === 400) {
        console.error("ListMensajerias.Component.getMisMensajerias response: ", response)
        createNotification('Ocurrió un error al consultar mis servicios de mensajería', 'error')
      } else {
        setMensajerias(response['data'])
      }
    } catch (error) {
      console.error('ListMensajerias.Component.getMisMensajerias error: ', error)
    }
  }

  const onCloseDetalle = () => {
    console.log("--ListMensajerias.Component.onCloseDetalle-- ");
    setVisibleDetalle(false)
  }

  const openDetalle = () => {
    console.log("--ListMensajerias.Component.openDetalle-- ");
    setVisibleDetalle(true)
  }

  return (
    <div className="col-9">

      <div className="row mt-3">
      <h2  style={{fontFamily: " Montserrat", color:'#2994CD', textAlign:'left', position:'relative', left:'25px' }}>Mis Servicios Mensajería</h2>

        <div className="col">
          <MensajeriaTable
            servicios={mensajerias}
            openDetalle={() => openDetalle()}
          />
        </div>
      </div>
      {visibleDetalle && (
        <DetalleMensajeria
          visibleDetalle={visibleDetalle}
          onCloseDetalle={() => onCloseDetalle()}
        />
      )}
    </div>
  )

}

export default withRouter(Connect(ListMensajerias))